
export function defaultQuestionAttempts(id: string): QuestionAttempts {
  return {
    id,
    attempts: []
  }
}

export interface QuestionAttempts {
  id: string
  attempts: QuestionAttempt[]
}

interface QuestionAttempt {
  thinkingTimeSeconds: number
  achievedScore: number
}
